import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { KeyboardArrowRight } from "../Widgets/Icon";
const constants = require("../constants");

export default function Expander(props) {
  const {
    expand,
    title,
    onClick,
    containerStyle = {},
    titleStyle = {},
    titleMobileStyle = {},
    containerMobileStyle,
    contentStyle = {},
    closable = true,
    children,
  } = props;

  let extraProps = {
    ...(onClick && { onClick }),
  };

  if (!children) {
    return (
      <SectionExpand
        style={containerStyle}
        containerMobileStyle={containerMobileStyle}
        titleMobileStyle={titleMobileStyle}
        {...extraProps}
      >
        {typeof title === "string" ? (
          <div style={titleStyle}>{title}</div>
        ) : (
          title
        )}
      </SectionExpand>
    );
  }

  return (
    <>
      {expand ? (
        <div style={{ ...contentStyle }}>{children}</div>
      ) : (
        <SectionExpand
          expand={expand}
          onClick={onClick}
          style={containerStyle}
          containerMobileStyle={containerMobileStyle}
          titleMobileStyle={titleMobileStyle}
        >
          {typeof title === "string" ? (
            <div style={{ flex: 1, ...titleStyle }}>{title}</div>
          ) : (
            <div style={{ flex: 1 }}>{title}</div>
          )}
          {!closable
            ? null
            : !expand && (
                <ArrowWrapper>
                  <p>編輯</p>
                  <KeyboardArrowRight
                    size={24}
                    color={constants.colors.highlight}
                  />
                </ArrowWrapper>
              )}
        </SectionExpand>
      )}
    </>
  );
}

const SectionExpand = styled.div`
  margin-bottom: ${(props) => (props.expand ? "10px" : "20px")};
  cursor: pointer;
  @media (max-width: 768px) {
    ${(props) => props.containerMobileStyle}
    & > div:nth-child(1) {
      ${(props) => props.titleMobileStyle}
    }
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  gap: 4px;
  position: absolute;
  right: 24px;
  top: 24px;
  height: 30px;
  align-self: start;
  font-size: 16px;
  color: ${constants.colors.highlight};

  p {
    margin: 0;
    height: 100%;
  }
`;
